import * as React from "react";

const SvgCallTrackingMetrics = (props, ref) => (
  <svg
    viewBox="0 0 255 255"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    {...{ ...props, ref }}
  >
    <path d="M0 0h154v154H0z" fill="#17B8E0" />
    <path d="M4 0 154 150v4h-4L0 4V0z" fill="#fff" />
    <path d="M159 0h96v154h-96z" fill="#17648B" />
    <path d="M159 159h96v96z" fill="#192B51" />
  </svg>
);
export default React.forwardRef(SvgCallTrackingMetrics);
